import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import Page from 'components/ui/page';

import nl2br from 'react-nl2br';

import _ from 'lodash';

import './index.less';
import {connect} from "react-redux";
import moment from "moment";
import formats from "dictionaries/formats";
import {Link} from "react-router";
import GlobalLoaderComponent from "components/ui/global-loader";
import Select, {SelectAsync} from 'components/ui/select';
import {getCarriers} from "store/reducers/organizational_units/carriers";
import TextField from "components/ui/text-field";
import Datepicker from "components/ui/form/datepicker";
import {portalSchedule, portalScheduleRoute, portalScheduleExtended} from "store/reducers/geo/schedule";
import Input from "components/ui/form/input";
import {printTable} from "helpers/print";
import $ from 'jquery';
import {getStopPoints} from "store/reducers/routes/routes";
import {routing} from "store/reducers/geo/geocoding";
import * as alerts from "helpers/alerts";
import InputMask from "components/ui/form/input-mask";

@connect((state) => ({}), {
    portalSchedule,
    portalScheduleExtended,
    portalScheduleRoute,
    getStopPoints,
    routing,
    getCarriers
})

export default class ScheduleComponent extends Component {

    state = {
        items: [],
        route_items: [],
        loading: false,
        number: null,
        label: null,
        date: moment(),
        time: moment().format(formats.TIME),
        selectedOrderRunUuid: null,
        from: null,
        to: null,
        routes: [],
    };

    componentDidMount() {
        this.loadRoutes();
    }

    async loadRoutes() {
        const response = await this.props.getCarriers({
            filters: {
                withComponent: 'kiutr',
            },
        });
        if (response.isOk) {
            this.setState({
                routes: _.sortBy(_.map(_.uniq(_.flatten(_.map(response.payload.items, 'routes'))), (item) => ({
                    value: item,
                    label: item,
                })), 'label'),
            });
        } else {
            response.showErrors();
        }
    }

    onChange(field, {target: {value}}) {
        if (field === 'time') { //чекаем введенное пользователем кривое время
            let hours = Number(value.split(':')[0]);
            let minutes = Number(value.split(':')[1]);
            if (!isNaN(hours) && hours > 23) {
                hours = 23
                value = `${hours}:${value.split(':')[1]}`
            }
            if (!isNaN(minutes) && minutes > 59) {
                minutes = 59
                value = `${value.split(':')[0]}:${minutes}`
            }
        }
        let state = this.state;
        state[field] = value;
        if (field === 'number') {
            state.from = null;
            state.to = null;
        }
        this.setState(state);
    }

    onChangeSelect(field, e) {
        const value = e || '';

        let state = this.state;
        /*state[field] = value;
        state.number = null;*/
        field === 'number' ? state[field] = value.value : state[field] = value;
        this.setState(state);
    }

    onChangeNumber(field, e) {
        const value = e ? e.value : null;
        const label = e ? e.label : null;
        let state = this.state;
        state[field] = value;
        state.label = label;
        this.setState(state);
    }

    reverse() {
        this.setState({
            from: this.state.to,
            to: this.state.from,
        });
    }

    async loadData() {
        if ((!this.state.from || !this.state.to) && !this.state.number) {
            alerts.error('Необходимо заполнить обязательные поля');
            return;
        }

        if (this.state.time.includes('_')) {
            let correctTime = this.state.time.replaceAll('_', '0');
            await this.setState({
                time: correctTime
            })
        }

        this.setState({loading: true});
        let response;
        if (this.state.number) {
            if (window.RNIS_SETTINGS.isNSO && this.state.from && this.state.to) {
                response = await this.props.portalScheduleExtended(this.state.label, moment(moment(this.state.date).format('YYYY-MM-DD') + ' ' + this.state.time).format(formats.DATETIME_API), this.state.from.value, this.state.to.value);
            } else {
                response = await this.props.portalSchedule(this.state.label, moment(moment(this.state.date).format('YYYY-MM-DD') + ' ' + this.state.time).format(formats.DATETIME_API));
            }

        } else {
            response = await this.routing();
        }
        this.setState({loading: false});

        if (response.isOk) {
            this.setState({
                items: response.payload.items,
            });
        } else {
            response.showErrors();
        }
    }

    async loadRouteData() {
        this.setState({loading: true});
        const response = await this.props.portalScheduleRoute(this.state.selectedOrderRunUuid);
        this.setState({loading: false});

        if (response.isOk) {
            this.setState({
                route_items: response.payload.items,
            });
        } else {
            response.showErrors();
        }
    }

    async selectRow(row) {
        const selectedOrderRunUuid = row.order_run_uuid;

        if (row.route_uuid) {
            await this.setState({
                selectedOrderRunUuid,
                route_items: [],
            });

            this.loadRouteData();
        } else {
            this.setState({
                selectedOrderRunUuid,
                route_items: row.stop_points,
            });
        }
    }

    closeSelected() {
        this.setState({
            selectedOrderRunUuid: null,
        });
    }

    render() {
        const loader = this.state.loading ? <GlobalLoaderComponent/> : null;

        return (
            <Page pageId="RouteList" title="Расписания">
                {loader}
                {this.state.selectedOrderRunUuid ? this.renderSelectedRoute() : this.renderRoutes()}
            </Page>
        );
    }

    renderRoutes() {
        return (
            <div className="page-block">
                <div className="page-block__header">
                    <div className="page-block__menu _lg">
                        <div className="page-block__menu-link page-block__menu-link_print" onClick={::this.print}/>
                    </div>

                    <div className="b-block _sm">
                        <div className="b-block__title">№ маршрута</div>
                        <div className="b-block__text">
                            <div className="input">
                                <Select
                                    value={this.state.number}
                                    onChange={this.onChangeNumber.bind(this, 'number')}
                                    //options={this.state.routes}
                                    options={_.map(this.state.routes, (item) => ({
                                        value: item.value.uuid,
                                        label: item.value.number
                                    }))}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="b-block _md">
                        <div className="b-block__title">Начальный пункт</div>
                        <div className="b-block__text">
                            <div className="input">
                                <SelectAsync
                                    name="from"
                                    value={_.get(this.state.from, 'value')}
                                    onChange={this.onChangeSelect.bind(this, 'from')}
                                    loadOptions={::this.loadStopPoints}
                                    options={this.state.from ? [_.cloneDeep(this.state.from)] : []}
                                />
                            </div>
                        </div>
                    </div>
                    <span className="reverse-direction full" onClick={::this.reverse}/>
                    <div className="b-block _md">
                        <div className="b-block__title">Конечный пункт</div>
                        <div className="b-block__text">
                            <div className="input">
                                <SelectAsync
                                    value={_.get(this.state.to, 'value')}
                                    onChange={this.onChangeSelect.bind(this, 'to')}
                                    loadOptions={::this.loadStopPoints}
                                    options={this.state.to ? [this.state.to] : []}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="b-block _sm">
                        <div className="b-block__title">Дата</div>
                        <div className="b-block__text">
                            <Datepicker
                                value={this.state.date}
                                onChange={this.onChange.bind(this, 'date')}
                            />
                        </div>
                    </div>
                    <div className="b-block _sm">
                        <div className="b-block__title">Время</div>
                        <div className="b-block__text">
                            <InputMask mask="99:99" value={this.state.time}
                                       onChange={this.onChange.bind(this, 'time')}  />

                        </div>
                    </div>
                    <div className="b-block _sm">
                        <button
                            onClick={::this.loadData}
                            className="b-button b-button_red b-button_shadow_red b-button_posit b-button_size_lg b-button_width_full">
                            Найти
                        </button>
                    </div>
                </div>

                <div className="b-block _xl">
                    <div className="table-container">
                        <div className="Table _no-indent">
                            <table className="b-table" ref="table">
                                <thead>
                                <tr className="b-table__header">
                                    <th/>
                                    <th>№</th>
                                    <th>Маршрут</th>
                                    <th>Отправление</th>
                                    <th>Время в пути</th>
                                    <th>Прибытие</th>
                                </tr>
                                </thead>
                                <tbody>
                                {_.map(_.sortBy(this.state.items, 'start_at'), ::this.renderItem)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    print() {
        const table = this.refs.table;
        const tableClone = $(table).clone();
        tableClone.find('td:first-child,th:first-child').remove();
        const headers = $(tableClone).find('th');
        const rows = $(tableClone).find('tbody tr');
        printTable(headers, rows, 'landscape', 'A4');
    }

    renderItem(item, index) {
        return (
            <tr key={index} onClick={this.selectRow.bind(this, item)}>
                <td>
                    <span className="icon-route-ts icon-route-ts_type_bus"/>
                </td>
                <td>{item.number}</td>
                <td>{item.title}</td>
                <td>
                    <span className="bold">{item.start_at}</span>
                    <span>{item.start_from}</span>
                </td>
                <td>{item.time} мин</td>
                <td>
                    <span className="bold">{item.end_at}</span>
                    <span>{item.end_from}</span>
                </td>
            </tr>
        );
    }z

    renderSelectedRoute() {
        const route = _.find(this.state.items, {order_run_uuid: this.state.selectedOrderRunUuid});
        const routeUuid = _.get(route, 'route_uuid');
        const nextRoute = _.first(_.sortBy(_.filter(_.filter(this.state.items, {route_uuid: routeUuid}), (item) => {
            return moment(item.start_at, formats.TIME).isSameOrAfter(moment(route.end_at, formats.TIME));
        }), 'start_at'));

        return (
            <div className="page-block">

                <div className="page-block__header">
                    <div className="page-block__menu _lg">
                        <div className="page-block__menu-link page-block__menu-link_print" onClick={::this.print}/>
                    </div>
                    <div className="page-block__title">
                        <span className="arrow-back" onClick={::this.closeSelected}/>
                        {route.start_from}
                        {nextRoute ? (
                            <span className="reverse-direction" onClick={this.selectRow.bind(this, nextRoute)}/>
                        ) : (
                            <span>&mdash;</span>
                        )}
                        {route.end_from}
                    </div>
                </div>

                <div className="b-block _xl">
                    <div className="table-container">
                        <div className="Table _no-indent">
                            <table className="b-table" ref="table">
                                <thead>
                                <tr className="b-table__header">
                                    <th>Остановка</th>
                                    <th>Местное время</th>
                                    <th>Время в пути</th>
                                </tr>
                                </thead>
                                <tbody>
                                {_.map(this.state.route_items, ::this.renderRouteItem)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        );
    }

    renderRouteItem(item, index) {
        if (_.isString(item)) {
            return (
                <tr key={index} className="transfer">
                    <td colSpan={3}>
                        <span className="bold">{item}</span>
                    </td>
                </tr>
            );
        }

        return (
            <tr key={index}>
                <td>{item.name}</td>
                <td>{item.arrival_time}</td>
                <td>{item.time ? `${item.time} мин` : null}</td>
            </tr>
        );
    }

    async loadStopPoints(input, callback) {
        if (!input) {
            callback(null, {
                options: [],
                complete: false,
            });
            return;
        }

        let filters = {
            withSource: 'inventarisation_active',
            withRoutes: [this.state.number]
        };

        if (!window.RNIS_SETTINGS.isNSO) {
            delete filters.withRoutes;
        }

        const response = await this.props.getStopPoints({
            search: input,
            pagination: {
                page: 1,
                limit: 10,
            },
            filters: filters
        });

        if (response.isOk) {
            callback(null, {
                options: _.sortBy(_.map(response.payload.items, (item) => ({
                    value: item.uuid,
                    label: item.title,
                    latitude: item.latitude,
                    longitude: item.longitude,
                })), 'label'),
                complete: false,
            });
        } else {
            response.showErrors();
        }
    }

    async routing() {
        const response = await this.props.routing({
            from: this.state.from,
            to: this.state.to,
            transit: [],
            datetime: moment(moment(this.state.date).format('YYYY-MM-DD') + ' ' + this.state.time).format(formats.DATETIME_API),
            version: 1,
            modes: [
                'TRANSIT',
            ],
        });

        if (response.isOk) {
            let currentRoute = null;

            return {
                isOk: true,
                payload: {
                    items: _.map(response.payload.items, (item, _index) => {
                        const points = _.filter(item.points, {type: 'bus'});
                        const start = this.timeToInt(_.get(_.first(points), 'time_at'));

                        return {
                            number: _.filter(_.uniq(_.map(points, 'route.number'))).join(', '),
                            title: _.get(this.state.from, 'label') + ' - ' + _.get(this.state.to, 'label'),
                            start_at: _.get(_.first(points), 'time_at'),
                            start_from: _.get(_.first(points), 'stop_point.name'),
                            end_at: _.get(_.last(points), 'time_at'),
                            end_from: _.get(_.last(points), 'stop_point.name'),
                            time: item.time,
                            order_run_uuid: _index + 1,
                            stop_points: _.flatten(_.map(_.filter(points, (point) => {
                                return point.stop_point;
                            }), (point, index) => {
                                if (!currentRoute) {
                                    currentRoute = point.route.number;
                                }
                                let result = [];
                                if (point.route.number !== currentRoute) {
                                    currentRoute = point.route.number;
                                    result.push(`Переход на маршрут № ${currentRoute}`);
                                }
                                return _.concat(result, [{
                                    name: point.stop_point.name,
                                    arrival_time: _.get(point, 'time_at'),
                                    time: this.timeToInt(_.get(point, 'time_at')) - start,
                                }]);
                            })),
                        };
                    }),
                },
            };
        } else {
            return response;
        }
    }

    intToTime(int) {
        const hours = _.padStart(Math.floor(int / 60), 2, '0');
        const minutes = _.padStart(int % 60, 2, '0');
        return `${hours}:${minutes}`;
    }

    timeToInt(time) {
        const timeObject = moment(time, formats.TIME);
        return timeObject.hours() * 60 + timeObject.minutes();
    }
}



// WEBPACK FOOTER //
// ./src/components/modules/schedule/index.js